import styled from 'styled-components';
import { customMedia } from '../../../../../styles/utils';

interface RevisionStyledProps {
  isOpen: boolean;
}

export const ChatRevisionsStyled = styled.div<RevisionStyledProps>(
  ({ theme, isOpen }) => {
    return {
      top: theme.space[1],
      position: 'absolute',
      width: 'calc(100% - 15px)',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      background: theme.color.wfWhite,
      zIndex: 1,
      boxShadow: isOpen ? '0 2px 10px rgb(0 0 0 / 10%)' : 'none',
    };
  },
);

export const RevisionsWrapperStyled = styled.div({
  width: '100%',
});

export const ChatDropdownButtonStyled = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  user-select: none;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  height: 24px;
  border-radius: 12px;
  border: 1px solid ${props => props.theme.color.wfGrey200};
  color: ${props => props.theme.color.wfGrey400};
  background-color: ${props => props.theme.color.wfWhite};
  z-index: 2;

  svg {
    margin-left: 8px;
  }

  h6 {
    color: ${props => props.theme.color.wfGrey500};
  }

  ${customMedia.lessThan('medium')`
    height: 44px;
    border-radius: 22px;
  `};
  &:hover {
    color: ${props => props.theme.color.wfGrey800};
    h6 {
      color: ${props => props.theme.color.wfGrey800};
    }
  }
`;
